import {Nullish} from 'shared/web';

export const hasSecondaryFuelType = (fuelType: string | Nullish) =>
  ['FUELTYPE_LPG', 'FUELTYPE_CNG', 'FUELTYPE_HYBRID', 'FUELTYPE_HYDROGEN'].includes(fuelType ?? '');
